import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76368246"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "init" }
const _hoisted_2 = { class: "init-page" }
const _hoisted_3 = { class: "init-wrap" }
const _hoisted_4 = { class: "init-wrap__header" }
const _hoisted_5 = { class: "init-title" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 欢迎使用协作空间 ")
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "init-desc" }, "灵活搭建 无限可能", -1))
const _hoisted_10 = { class: "init-wrap__content" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "init-wrap__footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("立即使用")
const _hoisted_14 = { key: 0 }

import {
  watch,
  nextTick,
  computed,
  ref,
  onBeforeMount,
  onBeforeUnmount
} from 'vue'
import { NButton, NScrollbar } from 'naive-ui'
import helloLeft from '@/assets/groupStatus/helloLeft.svg'
import helloRight from '@/assets/groupStatus/helloRight.svg'
import spaceIntroduce from '@/assets/groupStatus/spaceIntroduce.svg'
import { ACCOUNT } from '@plus/env/dist/index.esm.js'
import { useGroupStore } from '@/store/group'
import { useSingleGroupMemento } from '@teams/common/hooks/useMemento'
import { useRouter } from 'vue-router'
import { useUserStore } from '@teams/common/store/user'
import {
  showLoading as showAppRouterLoading,
  closeLoading as closeAppRouterLoading
} from '@/views/appRouterView/hooks'
import { useNavigatorStore } from '@/store/navigator'
import { useAccountChange } from '@teams/common/hooks/useAccountChange'
import SelectTemplate from '@/components/dialog/createGroup'
import useViewConfig from '@/hooks/useViewConfig'
import { useDrawer } from '@/components/drawer'
import { useTeamHead } from '@/components/teamHead'
import TeamHead from '@/components/teamHead/Index.vue'
import { useLocalStorage } from '@vueuse/core'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import usePreference from '@teams/common/hooks/usePreference'


export default /*#__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

_useCssVars(_ctx => ({
  "7c4d0fd8": (_unref(defaultBackgroundUrl))
}))

const preference = usePreference({ initBind: true })
const navigatorStore = useNavigatorStore()
const accountChange = useAccountChange()
const singleGroupMemento = useSingleGroupMemento()
const groupStore = useGroupStore()
const userStore = useUserStore()
const router = useRouter()
const selectTemplateRef = ref<{ openCreateSpaceDialog: () => void }>()
const { shouldStickyGroupPanel } = useViewConfig()
const { updateShareSettingValue } = useTeamShare()
const localStorage = useLocalStorage('INIT_PAGE_SPACE_ENTRY_GUIDE', true)
const showSpaceEnterGuide = ref(false)
const defaultBackgroundUrl = computed(
  () => `url(${preference.current.theme.styles['group-head-background-img']})`
)
// 固定的时候 noModal=true
const drawer = useDrawer()
const noModal = computed(() => shouldStickyGroupPanel.value)
const targetEnterGroupId = computed(
  () =>
    groupStore.stickyTopGroups?.[0]?.id ||
    groupStore.groups?.[0]?.id ||
    undefined
)
const isLogin = computed(() => !!userStore.userId)
const teamHead = useTeamHead({
  showTeamMemberEntry: computed(() => {
    return false
  }),
  isVisitor: computed(() => {
    return true
  }),
  isLogin: isLogin,
  stickyGroupPanel: computed(() => {
    // 未登录 显示(true)
    if (!isLogin.value) {
      return true
    }
    return shouldStickyGroupPanel.value
  }),
  hiddenTeamSpace: computed(() => true),
  hiddenTeamMember: computed(() => true),
  hiddenShareBtn: computed(() => true),
  hiddenMessageAlert: computed(() => true),
  isEase: computed(() => false),
  showLoginBtn: computed(() => !isLogin.value),
  showSpaceEnterGuide: showSpaceEnterGuide
})
const teamHeadRef = ref<{
  openDrawer: () => void
  setTeamListToolTipShow: (show: boolean) => void
}>()
const loadMyGroupData = async () => {
  await groupStore.reloadMyGroups()
}
const handleUseBtnClick = async () => {
  if (isLogin.value) {
    await loadMyGroupData()
    if (!targetEnterGroupId.value) {
      startCreateGuide()
    } else {
      startEnterSpace()
    }
  } else {
    location.href = `${ACCOUNT}?cb=${encodeURIComponent(
      location.href
    )}?enterSpace=true`
  }
}

const startCreateGuide = () => {
  // TODO: 现在的页面必须要在弹出团队列表以后才能弹模板选择弹窗，后续需要解耦
  selectTemplateRef.value?.openCreateSpaceDialog()
}

const startEnterSpace = async () => {
  if (isLogin.value) {
    if (targetEnterGroupId.value) {
      showAppRouterLoading()
      await changeGroup(targetEnterGroupId.value)
      closeAppRouterLoading()
    } else {
      closeAppRouterLoading()
    }
    if (!shouldStickyGroupPanel.value) {
      teamHeadRef.value?.openDrawer?.() // 有无团队都需展开团队列表抽屉
    }
  }
}

// 弹出时机 router.currentRoute.value.query.enterSpace !== 'true'
nextTick(() => {
  if (router.currentRoute.value.query.enterSpace !== 'true') {
    teamHeadRef.value?.setTeamListToolTipShow(true)
    setTimeout(() => {
      teamHeadRef.value?.setTeamListToolTipShow(false)
    }, 3000)
  }
})

const changeGroup = async (groupId: number) => {
  try {
    await singleGroupMemento.originator.changeState(() => ({
      groupId: groupId,
      userId: userStore.userId as number,
      shouldFlushStore: true,
      shouldFlushUsePreference: true,
      shouldFlushUseTeamShare: true
    }))
    await singleGroupMemento.changeGroup(groupId)
    const nav = navigatorStore.list?.[0]
    // 直接push不需要刷新即可完成首次进入团队
    router.push({
      name: 'Nav',
      params: {
        groupId: groupId
      },
      query: { nid: nav?.id }
    })
  } catch (error) {
    window.location.href = window.location.origin + `/${groupId}`
  }
}

watch(
  [() => router?.currentRoute?.value?.query?.enterSpace],
  async () => {
    if (router.currentRoute.value.query.enterSpace === 'true') {
      if (isLogin.value) {
        showAppRouterLoading()
      }
      await loadMyGroupData()
      startEnterSpace()
    }
  },
  {
    immediate: true
  }
)

onBeforeMount(async () => {
  updateShareSettingValue({ share_show_add_button: '1' }) // 隐藏加入团队入口
  if (localStorage.value) {
    showSpaceEnterGuide.value = localStorage.value
  }
})

onBeforeUnmount(() => {
  accountChange.updateMultiState('isChangeAccount', false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NScrollbar), { "x-scrollable": true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("header", null, [
            _createVNode(TeamHead, _mergeProps(_unref(teamHead).props, {
              ref_key: "teamHeadRef",
              ref: teamHeadRef
            }), null, 16)
          ]),
          _createElementVNode("main", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    class: "init-title__img",
                    src: _unref(helloLeft),
                    alt: ""
                  }, null, 8, _hoisted_6),
                  _hoisted_7,
                  _createElementVNode("img", {
                    class: "init-title__img",
                    src: _unref(helloRight),
                    alt: ""
                  }, null, 8, _hoisted_8)
                ]),
                _hoisted_9
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("img", {
                  class: "init-content__img",
                  src: _unref(spaceIntroduce),
                  alt: ""
                }, null, 8, _hoisted_11)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_unref(NButton), {
                  class: "init-footer__btn",
                  type: "primary",
                  size: "large",
                  onClick: handleUseBtnClick
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                (!_unref(drawer).visible.value)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_unref(SelectTemplate), {
                        "no-modal": _unref(noModal),
                        "is-login": true,
                        ref_key: "selectTemplateRef",
                        ref: selectTemplateRef
                      }, null, 8, ["no-modal"])
                    ], 512)), [
                      [_vShow, false]
                    ])
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})